export const SCHOOL = "http://146.190.105.231:7093";
export const CANDIDATE = "http://146.190.105.231:7094";
export const COMPANY = "http://146.190.105.231:7095";

export const WHATSAPP_NUMBER = "+6281290328046";
